import React from "react";
import styles from "../../styles/components/product/ProductAiVerdictCard.module.css";
import { getFitScoreBandLabel, formatFitScoreBadge } from "../../utils/matchScoreUtils";

const getVerdictLabel = (percentage) => {
  const label = getFitScoreBandLabel(percentage);
  if (percentage >= 80) return { label, className: styles.strong };
  if (percentage >= 60) return { label, className: styles.good };
  return { label, className: styles.weak };
};

const ProductAiVerdictCard = ({
  matchData,
  aiSessionRank = null,
  topAiPick = null,
  topPickScoreDiff = null,
  onCompareWithTopPick,
  onAskAi,
}) => {
  if (matchData?.percentage == null) return null;

  const verdict = getVerdictLabel(matchData.percentage);
  const reasons = (matchData.reasons || []).slice(0, 3);

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={`${styles.verdictBadge} ${verdict.className}`}>
          {verdict.label}
        </span>
        <span className={styles.score}>{formatFitScoreBadge(matchData.percentage)}</span>
        {aiSessionRank != null && (
          <span className={styles.rankBadge}>In your AI matches (#{aiSessionRank})</span>
        )}
      </div>

      {matchData.dealBreakerFailed && (
        <p className={styles.warning}>
          This product is missing a must-have feature from your profile.
        </p>
      )}

      {reasons.length > 0 && (
        <ul className={styles.reasons}>
          {reasons.map((reason, idx) => (
            <li key={idx}>{reason}</li>
          ))}
        </ul>
      )}

      {topAiPick && topPickScoreDiff != null && topPickScoreDiff > 0 && (
        <p className={styles.pickNote}>
          Your #1 pick ({topAiPick.name}) scores {topPickScoreDiff} points higher
        </p>
      )}

      <div className={styles.actions}>
        {topAiPick && onCompareWithTopPick && (
          <button type="button" className={styles.actionBtn} onClick={onCompareWithTopPick}>
            Compare with #1 pick
          </button>
        )}
        {onAskAi && (
          <button type="button" className={styles.actionBtnSecondary} onClick={onAskAi}>
            Ask AI why
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductAiVerdictCard;
